<template>
  <div class="outer-wrapper">
    <div class="inner-page animate__animated animate__slideInRight">
      <b-container fluid>
        <b-form @submit.prevent="createMeeting">
          <h1 class="title mb-3">Add New Meeting</h1>
          <div class="">
            <button v-b-modal.modal-new-record type="button" class="record-card" v-if="isStopActive">
              <div class="record-title">
                <span class="icon-sm mic-icon"></span>
                <span>Record Meeting</span>
              </div>
              <div class="record-subtitle">Tap here and start recording</div>
            </button>
            <button type="button" class="record-card" v-else-if="!startButton" @click="startRecord">
              <div class="record-title">
                <span class="icon-sm mic-icon"></span>
                <span>Record Meeting</span>
              </div>
              <div class="record-subtitle">Tap here and start recording</div>
            </button>
            <div class="record-card" v-else>
              <div class="record-title">
                <span class="icon-sm mic-icon"></span>
                <span class="b-skeleton-animate-fade"
                  v-if="startButton && !isPauseActive && !isStopActive">Recording</span>
                <span v-if="isPauseActive">Recording Paused</span>
              </div>
              <div class="record-time">
                <span class="icon-xs clock-icon"></span>
                <span>{{ recordingTime.min }}:{{ recordingTime.sec }}</span>
              </div>
              <button type="button" class="record-btn btn-pause" @click="resumeAudio" v-if="isPauseActive">
                <span class="icon-sm resume-icon"></span>
                <span>RESUME</span>
              </button>
              <button type="button" class="record-btn btn-pause" @click="pauseAudio" v-else>
                <span class="icon-sm pause-icon"></span>
                <span>PAUSE</span>
              </button>
              <button type="button" class="record-btn btn-stop" @click="stopRecord">
                <span class="icon-sm stop-icon"></span>
                <span>STOP</span>
              </button>
            </div>
            <div class="recorded-card" v-if="isStopActive">
              <div class="recorded-title">Recording 1</div>
              <div class="flex-wrapper">
                <div class="recorded-subtitle" v-if="!isAudioPlaying">
                  <span class="icon-xs calendar-icon"></span>
                  <span>{{recordingTime.date}} · {{recordingTime.time}}</span>
                </div>
                <div class="recorded-subtitle">
                  <span class="icon-xs clock-icon"></span>
                  <span>{{ formatedTime}}</span>
                </div>
              </div>
              <button type="button" class="recorded-btn play" v-if="isAudioPlaying" @click="stopSound">
                <span class="icon-sm stop-b-icon"></span>
                <span>STOP</span>
              </button>
              <button type="button" class="recorded-btn play" @click.prevent="playSound()" v-else>
                <span class="icon-sm play-icon"></span>
                <span>PLAY</span>
              </button>
              <button type="button" class="recorded-btn save" @click="downloadAudio">
                <span class="icon-sm down-icon"></span>
                <span>SAVE</span>
              </button>
            </div>
            <div class="audio-disclaimer" v-if="isStopActive">Warning: Starting a new recording will delete this one
            </div>
            <div style="opacity: 0;">
              <audio ref="audioPlayer"></audio>
            </div>
          </div>
          <b-modal content-class="border-0" id="modal-new-record" class="modal" centered hide-footer hide-header>
            <div class="row text-center justify-content-center pt-3">
              <div class="col-12">
                <svg class="" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_2198_123" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
                <rect width="32" height="32" fill="#D9D9D9"/>
                </mask>
                <g mask="url(#mask0_2198_123)">
                <path d="M4.56743 27.3333C4.34143 27.3333 4.13843 27.278 3.95843 27.1676C3.77843 27.0571 3.63854 26.9115 3.53877 26.7306C3.43477 26.551 3.37754 26.3566 3.3671 26.1473C3.35665 25.9379 3.4131 25.7306 3.53643 25.5253L14.9508 5.80793C15.0743 5.6026 15.2288 5.45082 15.4141 5.3526C15.5997 5.25437 15.795 5.20526 16.0001 5.20526C16.2052 5.20526 16.4005 5.25437 16.5861 5.3526C16.7714 5.45082 16.9259 5.6026 17.0494 5.80793L28.4638 25.5253C28.5871 25.7306 28.6435 25.9379 28.6331 26.1473C28.6226 26.3566 28.5654 26.551 28.4614 26.7306C28.3617 26.9115 28.2218 27.0571 28.0418 27.1676C27.8618 27.278 27.6588 27.3333 27.4328 27.3333H4.56743ZM5.93343 25.3333H26.0668L16.0001 7.99993L5.93343 25.3333ZM16.0001 23.7436C16.3052 23.7436 16.561 23.6404 16.7674 23.4339C16.9739 23.2275 17.0771 22.9717 17.0771 22.6666C17.0771 22.3615 16.9739 22.1057 16.7674 21.8993C16.561 21.6928 16.3052 21.5896 16.0001 21.5896C15.695 21.5896 15.4392 21.6928 15.2328 21.8993C15.0263 22.1057 14.9231 22.3615 14.9231 22.6666C14.9231 22.9717 15.0263 23.2275 15.2328 23.4339C15.4392 23.6404 15.695 23.7436 16.0001 23.7436ZM16.0004 20.2563C16.284 20.2563 16.5214 20.1605 16.7128 19.9689C16.9043 19.7771 17.0001 19.5396 17.0001 19.2563V14.5896C17.0001 14.3063 16.9042 14.0688 16.7124 13.8773C16.5207 13.6855 16.2831 13.5896 15.9998 13.5896C15.7162 13.5896 15.4788 13.6855 15.2874 13.8773C15.0959 14.0688 15.0001 14.3063 15.0001 14.5896V19.2563C15.0001 19.5396 15.096 19.7771 15.2878 19.9689C15.4795 20.1605 15.7171 20.2563 16.0004 20.2563Z" fill="#273444"/>
                </g>
              </svg>
              </div>
              <p class="mt-3 mb-4">New recording will delete the current one.<br>Are you sure you want to proceed?</p>
              <div class="col-6 pl-2 pr-1">
                <button class="btn-modal-cancel" type="button" @click="$bvModal.hide('modal-new-record');">Cancel</button>
              </div>
              <div class="col-6 pl-1 pr-2">
                <button class="btn-modal-continue" @click="startNewRecord">Yes, Continue</button>
              </div>
            </div>
          </b-modal>
          <div class="card">
            <div class="card-body p-2">
              <div class="form-group p-2 mb-1">
                <label for="firmName">Broker<span class="text-danger">*</span></label>
                <multiselect v-model="addMeeting.lead_uuid" :searchable="true" class="form-multiselect"
                  :placeholder="propertyNoInput" label="full_name" track-by="uuid" :options="brokerList"
                  :taggable="true" @search-change="suggestBrokers"></multiselect>
              </div>

              <div class="form-group p-2 mb-1">
                <label for="firmName">Meeting Date<span class="text-danger">*</span></label>
                <input type="datetime-local" class="form-control" placeholder="Meeting Date" required
                  ref="empanelmentdate" v-model="addMeeting.date" />
              </div>
              <div class="form-group p-2 mb-1">
                <CanmeraImageCapture ref="cameraCapture" />
              </div>
              <div class="form-group p-2 mb-1">
                <label>My Location<span class="text-danger">*</span></label>
                <b-form-input type="text" v-model="addMeeting.location" readonly required
                  placeholder="Find My Location"></b-form-input>
              </div>
              <div class="form-group p-2 mb-1">
                <label for="firmName">Meeting Questionare</label>
                <input type="file" id="myFile" name="filename" @change="uploadQuestionare">
              </div>
              <div class="form-group p-2 mb-1">
                <label for="Comment">Comment</label>
                <textarea type="text" class="form-control" placeholder="Enter Comment" ref="Comment" rows="3"
                  v-model="addMeeting.comment"></textarea>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="form-group m-0">
              <button type="submit" class="btn btn-primary btn-block">
                Save
              </button>
            </div>
          </div>
        </b-form>
      </b-container>
    </div>
  </div>
</template>
<script>
import { decodeMeetingParams } from '@/assets/scripts/utility.js';
import Multiselect from 'vue-multiselect';
import { required, minLength, maxLength, email } from 'vuelidate/lib/validators';
import { validationMessage } from 'vuelidate-messages'
import AudioRecorder from 'audio-recorder-polyfill';
import mpegEncoder from 'audio-recorder-polyfill/mpeg-encoder';

const formMessages = {
  required: () => 'Field is required',
  txtMinLen: ({ $params }) => `Must be at least ${$params.txtMinLen.min} characters.`,
  txtMaxLen: ({ $params }) => `Must be at most ${$params.txtMaxLen.max} characters.`,
  email: () => 'Should be valid email',
}

// Forcing polyfill for better compression and compatability
AudioRecorder.encoder = mpegEncoder;
AudioRecorder.prototype.mimeType = 'audio/mpeg';
window.MediaRecorder = AudioRecorder;

export default {
  components: {
    Multiselect,
    CanmeraImageCapture: () => import('@/components/Forms/CameraImageCapture.vue')
  },
  name: "NewMeeting",
  data: () => {
    return {
      brokerList: [],
      finalChunks: [],
      startButton: false,
      pauseButton: true,
      resumeButton: true,
      stopButton: true,
      downloadButton: true,
      isStartActive: true,
      isPauseActive: false,
      isResumeActive: false,
      isStopActive: false,
      startTime: null,
      durationInSeconds: null,
      isAudioPlaying: false,
      audioPlayingTime: 0,
      playingAudioFile: null,
      recordingTime: {
        min: '00' ,
        sec: '00',
        date: '',
        time: ''
      },
      recordingStartTime: null,
      recordingInterval: null,
      isDownload: false,
      addMeeting: {
        lead_uuid: null,
        date: null,
        attachment: null,
        location: '',
        meeting_executive_lat: '',
        meeting_executive_long: '',
        comment: null,
        recorded_audio_duration: null,
        recording: null,
      },
      meeting_questionare: null,
      propertyNoInput: null,
    };
  },
  validations: {
    lead: {
      full_name: {
        required
      },
      firm_name: {
        required
      },
      primary_phone: {
        required,
        txtMinLen: minLength(8),
        txtMaxLen: maxLength(15)
      },
      primery_email: {
        email
      }
    },
    selectedStatus: {
      required
    },
  },
  created() {
    this.getCurrentPosition();
  },
  methods: {
    formatTime(time){
        let minutes = Math.floor(time / 60);
        let seconds = Math.floor(time - (minutes * 60));
        return minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0');
    },
    handlePlayState(){
      this.isAudioPlaying = true
    },
    handleTimeUpdate(){
      this.audioPlayingTime = this.$refs.audioPlayer.currentTime
    },
    handlePauseState(){
      this.isAudioPlaying = false;
      this.audioPlayingTime = this.$refs.audioPlayer.duration
    },
    handleAudioEnd(){
      this.isAudioPlaying = false;
      // Remove event listeners
      this.$refs.audioPlayer.removeEventListener('playing', this.handlePlayState);
      this.$refs.audioPlayer.removeEventListener('timeupdate', this.handleTimeUpdate );
      this.$refs.audioPlayer.removeEventListener('pause', this.handlePauseState);
    },
    startNewRecord(){
      this.$bvModal.hide('modal-new-record');
      this.recordingTime = {
        min: '00' ,
        sec: '00',
        date: '',
        time: ''
      }
      this.startRecord();
    },
    startRecord() {
      let date = new Date();
      // Set recording start time and format it
      this.recordingStartTime = date.getTime(); 
      this.recordingTime.date = date.toLocaleDateString('en-IN', {
        timeZone: "Asia/Kolkata",
        day: '2-digit',
        month: '2-digit',
      });
      this.recordingTime.time = date.toLocaleTimeString('en-IN', {
        timeZone: "Asia/Kolkata",
        hour: '2-digit', 
        minute: '2-digit'
      });

      // Update UI states for recording
      this.isStopActive = false;
      this.isStartActive = true;
      this.isDownload = true;
      this.startButton = true;
      this.pauseButton = false;
      this.stopButton = false;

      // Update recording time every second
      this.recordingInterval = setInterval(() => {
        if (!this.isPauseActive) {
          let currentTime = new Date().getTime();
          let timeDiff = currentTime - this.recordingStartTime;
          let minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
          let seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
          this.recordingTime.min = minutes.toString().padStart(2, '0');
          this.recordingTime.sec = seconds.toString().padStart(2, '0');
        }
      }, 1000);

      this.finalChunks = [];
      this.startTime = Date.now();
      navigator.mediaDevices.getUserMedia({ audio: true })
        .then((stream) => {
          // Initialize MediaRecorder (or polyfill)
          this.mediaRecorder = new MediaRecorder(stream);
          this.mediaRecorder.start();
          this.mediaRecorder.addEventListener('dataavailable', (event) => {
            this.finalChunks.push(event.data);
          })
          console.log("Recording started");
          this.mediaRecorder.addEventListener('stop', () => {
            const tracks = stream.getTracks();
            tracks.forEach(track => track.stop());
          });
        })
        .catch((error) => {
          console.error("Error accessing audio devices.", error);
      });
    },
    stopRecord() {
      if (this.startTime) {
        this.durationInSeconds += Date.now() - this.startTime;
      }
      clearInterval(this.recordingInterval);
      this.durationInSeconds /= 1000;

      this.addMeeting.recorded_audio_duration = this.durationInSeconds;

      // Update UI states for stopping recording
      this.isStopActive = true;
      this.isResumeActive = false;
      this.isPauseActive = false;
      this.startButton = false;
      this.pauseButton = true;
      this.resumeButton = true;
      this.stopButton = true;
      this.downloadButton = false;

      this.mediaRecorder.stop();

      // Handle when the recording stops
      this.mediaRecorder.addEventListener("stop", () => {
        const audioBlob = new Blob(this.finalChunks, { type: "audio/mpeg" });
        this.addMeeting.recording = audioBlob;
        this.recordedVoice = URL.createObjectURL(audioBlob);
        this.$refs.audioPlayer.src =  URL.createObjectURL(audioBlob);
      });
      console.log("Recording stopped");
    },
    pauseAudio() {
      this.recordingStartTime = new Date().getTime() - this.recordingStartTime;
      this.durationInSeconds += Date.now() - this.startTime;
      this.startTime = null;

      this.mediaRecorder.pause();

      // Update UI states for pausing recording
      this.isResumeActive = false;
      this.isStartActive = false;
      this.isPauseActive = true;
      this.pauseButton = true;
      this.resumeButton = false;
      this.stopButton = false;
      console.log("Recording paused");
    },
    resumeAudio() {
      this.recordingStartTime = new Date().getTime() - this.recordingStartTime;
      this.startTime = Date.now();
      this.mediaRecorder.resume();
      // Update UI states for resuming recording
      this.isResumeActive = true;
      this.isPauseActive = false;
      this.resumeButton = true;
      this.pauseButton = false;
      console.log("Recording resumed");
    },
    downloadAudio() {
      if (this.finalChunks) {
        console.log("Final chunks:", this.finalChunks);
        const blob = new Blob(this.finalChunks, { type: "audio/mpeg" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        const timestamp = Date.now();
        a.href = url;
        a.download = `${timestamp}`;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        this.isDownload = false;
      }
    },
    playSound() {
      this.handleTimeUpdate();
      this.$refs.audioPlayer.play();
      // Update UI state while audio is playing
      this.$refs.audioPlayer.addEventListener('playing', this.handlePlayState);

      // Update time while audio is playing
      this.$refs.audioPlayer.addEventListener('timeupdate', this.handleTimeUpdate );

      // Update UI state while audio is paused
      this.$refs.audioPlayer.addEventListener('pause', this.handlePauseState);
      // Reset when audio ends
      this.$refs.audioPlayer.addEventListener("ended", this.handleAudioEnd);
    },
    stopSound() {
      this.$refs.audioPlayer.pause();
      this.audioPlayingTime = this.$refs.audioPlayer.duration;
      this.isAudioPlaying = false;
    },
    suggestBrokers(event) {
      if (event.length === 4) {
        event = encodeURIComponent(event)
        this.$axios.get(`/meetings/broker_info?name=${event.trim()}`)
          .then(res => {
            this.propertyNoInput = "No Results!"
            if (res.data.leads.length > 0) {
              this.brokerList = res.data.leads
            }
          })
          .catch(err => {
            this.propertyNoInput = "Something Went Wrong!"
          })
      }
    },
    getCurrentPosition() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          this.addMeeting.meeting_executive_lat = position.coords.latitude;
          this.addMeeting.meeting_executive_long = position.coords.longitude;
          this.getStreetAddressFrom(position.coords.latitude, position.coords.longitude);
        }, (error) => {
          console.log(error);
        }, { timeout: 10000, enableHighAccuracy: true, maximumAge: 0 });
      } else {
        //Geolocation is not supported by this browser
        console.log('Geolocation is not supported by this browser');
      }
    },
    async getStreetAddressFrom(lat, long) {
      var self = this;
      try {
        const { data } = await self.$axios.get(
          "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
          lat +
          "," +
          long +
          "&key=AIzaSyCDi6loOYUz1fXzMJpqI_83UlcdPrp86Fg"
        );
        if (data.error_message) {
          console.log(data.error_message)
        } else {
          this.addMeeting.location = data.results[0].formatted_address;
        }
      } catch (error) {
        console.log(error);
      }
    },
    uploadQuestionare() {
      this.addMeeting.attachment = event.target.files[0];
    },
    createMeeting() {
      this.addMeeting.executive_image = this.$refs.cameraCapture.finalImage;
      if (!this.addMeeting.executive_image) {
        this.$refs.cameraCapture.checkPhoto = true;
        return;
      } else {
        this.$refs.cameraCapture.checkPhoto = false;
      }
      let apiParams = decodeMeetingParams(this.addMeeting);
      this.$axios
        .post("meetings", apiParams, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then((res) => {
          this.$refs.cameraCapture.stopCameraStream();

          swal({
            title: "Meeting Created!",
            icon: "success",
          }).then(this.$router.replace({ name: "Meetings" }));
        })
        .catch((err) => {
          if (err.response.status === 500) {
            swal({
              title: "Server Error!",
              icon: "error",
            });
          } else {
            swal({
              title: "Error",
              text: err.response.data.message,
              icon: "error",
            });
          }
        });
    },
  },
  computed: {
    formatedTime(){
      return this.formatTime(this.audioPlayingTime);
    },
    localityList() {
      return this.$store.getters.localitiesMaster;
    },
    statusList() {
      return this.$store.getters.statusesMaster;
    },
    executiveList() {
      return this.$store.getters.executiveMaster;
    },
    validationMsg() {
      return validationMessage(formMessages);
    }
  },
  mounted() {
    // Updating recorded audio time for accuracy
    this.$refs.audioPlayer.addEventListener('durationchange', (e) => {
      this.audioPlayingTime = this.$refs.audioPlayer.duration;
    })
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
label {
  letter-spacing: 0.01em;
  font-size: 14px;
  font-weight: 500;
}

.form-control {
  font-size: 14px;
}

.record-card{
  display: block;
  width: 100%;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  border: 0.5px solid rgba(220, 220, 220, 1);
  background-color: rgba(255, 255, 255, 1);
  border-radius: 6px;
  text-align: left;
  padding: 12px;
  margin-bottom: 16px;
  position: relative;
}

.record-title{
  display: flex;
  align-items: center;
  gap: 4px;
  color: rgba(240, 89, 42, 1);
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 10px;
}

.record-subtitle, .record-time{
  font-size: 13px;
  font-weight: 400;
  line-height: 15.73px;
  color: rgba(39, 52, 68, 1);
  padding-bottom: 2px;
  padding-left: 4px;
}

.record-time{
  display: flex;
  align-items: center;
  gap: 7px;
}

.record-btn{
  position: absolute;
  display: flex;
  top: 5px;
  height: 61px;
  height: calc(100% - 10px);
  width: 64px;
  border-radius: 4px;
  border: none;
  outline: none;
  background-color: transparent;
  z-index: 2;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
  font-size: 14px;
  font-weight: 700;
  line-height: 11px;
  color: rgba(39, 52, 68, 1);
}

.btn-pause{
  right: 80px
}

.btn-stop{
  color: rgba(240, 42, 42, 1);
  background-color: rgba(240, 42, 42, 0.1);
  right: 5px;
}

.recorded-card{
  border: 1px solid rgba(220, 220, 220, 1);
  background-color: rgba(246, 246, 246, 1);
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 8px;
  position: relative;
}

.recorded-title{
  font-size: 12px;
  font-weight: 600;
  line-height: 14.52px;
  color: rgba(39, 52, 68, 1);
  margin-bottom: 8px;
}

.flex-wrapper{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  color: rgba(39, 52, 68, 0.5);
}

.flex-wrapper .recorded-subtitle{
  display: flex;
  align-items: center;
  gap: 4px;
  text-transform: uppercase;
}

.audio-disclaimer{
  font-size: 10px;
  font-weight: 500;
  line-height: 12.1px;
  text-align: center;
  color: rgba(39, 52, 68, 1);
  margin-bottom: 30px;
}

.recorded-btn{
  background-color: transparent;
  padding: 4px;
  outline: none;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  position: absolute;
  height: calc(100% - 10px);
  top: 5px;
  font-size: 10px;
  font-weight: 700;
  line-height: 12.1px;
  text-align: center;
  color: rgba(39, 52, 68, 1);
}

.recorded-btn.save{
  right: 5px;
}

.recorded-btn.play{
  right: 46px;
}

.btn-modal-cancel, .btn-modal-continue{
  display: block;
  width: 100%;
  border-radius: 6px;
  border: none;
  outline: none;
  background-color: rgba(246, 246, 246, 1);
  font-size: 13px;
  font-weight: 600;
  line-height: 15.73px;
  text-align: center;
  color: rgba(39, 52, 68, 1);
  padding: 12px;
}

.btn-modal-continue{
  background-color: rgba(39, 52, 68, 1);
  color: #fff;
}
</style>